module.exports = __webpack_public_path__ + "img/bar.bd4c7e62.svg";